import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.getConfirmStudentList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.getConfirmStudentList.error;
export const confirmStudentListResponse = (state: RootState) =>
  state.getConfirmStudentList.confirmStudentListResponse;
